import { render } from "./Input.vue?vue&type=template&id=6cd1a840"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=6cd1a840&lang=css"
script.render = render

export default script